<!-- @format -->
<button
	class="warranty-button hmf-display-flex hmf-align-items-center hmf-justify-content-between hmf-p-xs hmf-p-m-s background-base hmf-w-100"
	[ngClass]="{ disabled: variant().disabled }"
	(click)="buttonClick(variant().buttonAction, $event)">
	<div class="hmf-display-flex hmf-align-items-center">
		<homefield-icon
			name="security-verified-user"
			width="24px"
			height="24px"
			[fill]="variant().iconColor"
			class="hmf-mr-xxs" />
		<div class="hmf-display-flex hmf-flex-column hmf-align-items-flex-start">
			<div
				class="hmf-body-m"
				[class.hmf-body-bold-m]="variant().showWarrantyDetails"
				[ngClass]="{
					'hmf-body-bold-s hmf-body-bold-m-m': variant().subtext
				}">
				{{ variant().text }}
			</div>
			@if (variant().subtext) {
				<div class="hmf-body-s">{{ variant().subtext }}</div>
			}
			@let warrantyDetails = selectedWarrantyDetails();
			@let qty = atcUserInputQty();
			@if (variant().showWarrantyDetails && warrantyDetails) {
				<div class="hmf-body-m hmf-text-align-left">
					{{ warrantyDetails.planDisplayName }}
					{{ warrantyDetails.sellingPrice ? `| ${warrantyDetails.sellingPrice | currency}` : '' }}
					{{ qty > 1 ? `| Qty: ${qty}` : '' }}
				</div>
			}
		</div>
	</div>
	@if (!variant().disabled) {
		<homefield-icon
			name="chevron-right"
			width="24px"
			height="24px" />
	}
</button>

<pdp-component-warranty-selection-drawer></pdp-component-warranty-selection-drawer>
